import _defineProperty from "@babel/runtime/helpers/esm/defineProperty";
import _objectWithoutProperties from "@babel/runtime/helpers/esm/objectWithoutProperties";
import _taggedTemplateLiteral from "@babel/runtime/helpers/esm/taggedTemplateLiteral";
var _excluded = ["children", "customListItemTag", "hideStateVisibility", "href", "isDisabled", "isSelected", "onClick", "renderCustomAnchorElement", "tooltip"],
    _excluded2 = ["setTooltipText", "showTooltip"];

var _templateObject, _templateObject2, _templateObject3, _templateObject4, _templateObject5, _templateObject6, _templateObject7, _templateObject8, _templateObject9;

function ownKeys(object, enumerableOnly) {
  var keys = Object.keys(object);

  if (Object.getOwnPropertySymbols) {
    var symbols = Object.getOwnPropertySymbols(object);
    enumerableOnly && (symbols = symbols.filter(function (sym) {
      return Object.getOwnPropertyDescriptor(object, sym).enumerable;
    })), keys.push.apply(keys, symbols);
  }

  return keys;
}

function _objectSpread(target) {
  for (var i = 1; i < arguments.length; i++) {
    var source = null != arguments[i] ? arguments[i] : {};
    i % 2 ? ownKeys(Object(source), !0).forEach(function (key) {
      _defineProperty(target, key, source[key]);
    }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)) : ownKeys(Object(source)).forEach(function (key) {
      Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key));
    });
  }

  return target;
}

import React, { useEffect } from 'react';
import { NormalizedButton } from "../../../button";
import { BREAKPOINTS, ElementStateWrapper, getHexToRgb, getRem, transitionAnimation } from "../../../core";
import { withTooltip, TOOLTIP_HORIZONTAL_ALIGNMENTS, TOOLTIP_VERTICAL_ALIGNMENTS } from "../../../tooltip";
import { THEMES } from "../../../utilities";
import isBoolean from 'lodash/isBoolean';
import isEmpty from 'lodash/isEmpty';
import PropTypes from 'prop-types';
import styled, { css } from 'styled-components';
import { LIST_ITEM_DIVIDER_TYPES, LIST_SIZES } from "../../constants";
import { listItemStateStyles, listItemSelectedStyles } from "../listItemStateStyles";
import { jsx as _jsx } from "react/jsx-runtime";
var withAvatarStyles = css(_templateObject || (_templateObject = _taggedTemplateLiteral(["\n  height: ", ";\n  ", "\n"])), getRem(56), function (_ref) {
  var size = _ref.size;
  return size === LIST_SIZES.STANDARD && css(_templateObject2 || (_templateObject2 = _taggedTemplateLiteral(["\n      @media ", " {\n        height: ", ";\n      }\n    "])), BREAKPOINTS.L, getRem(48));
});
var multiLineStyles = css(_templateObject3 || (_templateObject3 = _taggedTemplateLiteral(["\n  height: ", ";\n  ", "\n"])), getRem(72), function (_ref2) {
  var size = _ref2.size;
  return size === LIST_SIZES.STANDARD && css(_templateObject4 || (_templateObject4 = _taggedTemplateLiteral(["\n      @media ", " {\n        height: ", ";\n      }\n    "])), BREAKPOINTS.L, getRem(60));
});
var withDividerStyles = css(_templateObject5 || (_templateObject5 = _taggedTemplateLiteral(["\n  &::after {\n    border-bottom: ", ";\n    bottom: 0;\n    content: '';\n    display: block;\n    left: 0;\n    position: absolute;\n    width: 100%;\n    ", "\n  }\n"])), function (_ref3) {
  var theme = _ref3.theme;
  return "1px solid rgba(".concat(getHexToRgb(theme.color.additional.dark.value), ", 0.3)");
}, function (_ref4) {
  var dividerType = _ref4.dividerType;
  return dividerType === LIST_ITEM_DIVIDER_TYPES.INSET && css(_templateObject6 || (_templateObject6 = _taggedTemplateLiteral(["\n        margin-left: ", ";\n      "])), getRem(48));
});
var selectableStyles = css(_templateObject7 || (_templateObject7 = _taggedTemplateLiteral(["\n  cursor: pointer;\n\n  &:hover {\n    background-color: ", ";\n  }\n\n  &:focus {\n    background-color: ", ";\n  }\n\n  &:active {\n    background-color: ", ";\n  }\n"])), function (_ref5) {
  var theme = _ref5.theme;
  return theme.color.state["default"].hover.value;
}, function (_ref6) {
  var theme = _ref6.theme;
  return theme.color.state["default"].focus.value;
}, function (_ref7) {
  var theme = _ref7.theme;
  return theme.color.state["default"].pressed.value;
});
var StyledListItem = styled.li(_templateObject8 || (_templateObject8 = _taggedTemplateLiteral(["\n  ", ";\n  align-items: center;\n  background-color: transparent;\n  border: none;\n  box-sizing: border-box;\n  display: flex;\n  flex-direction: row;\n  height: ", ";\n  justify-content: flex-start;\n  overflow: hidden;\n  padding: 0 ", ";\n  position: relative;\n  text-align: left;\n  text-decoration: none;\n  width: 100%;\n  ", "\n\n  ", ";\n  ", ";\n  ", "\n  ", "\n"])), transitionAnimation('background-color'), getRem(56), getRem(12), function (_ref8) {
  var size = _ref8.size;
  return size === LIST_SIZES.STANDARD && css(_templateObject9 || (_templateObject9 = _taggedTemplateLiteral(["\n      @media ", " {\n        height: ", ";\n      }\n    "])), BREAKPOINTS.L, getRem(40));
}, function (_ref9) {
  var hasAvatar = _ref9.hasAvatar;
  return hasAvatar && withAvatarStyles;
}, function (_ref10) {
  var isSelectable = _ref10.isSelectable;
  return isSelectable && selectableStyles;
}, function (_ref11) {
  var isMultiLine = _ref11.isMultiLine;
  return isMultiLine && multiLineStyles;
}, function (_ref12) {
  var isLastItem = _ref12.isLastItem,
      showDivider = _ref12.showDivider;
  return showDivider && !isLastItem && withDividerStyles;
});
var ListItem = /*#__PURE__*/React.forwardRef(function (_ref13, ref) {
  var children = _ref13.children,
      customListItemTag = _ref13.customListItemTag,
      hideStateVisibility = _ref13.hideStateVisibility,
      href = _ref13.href,
      isDisabled = _ref13.isDisabled,
      isSelected = _ref13.isSelected,
      _onClick = _ref13.onClick,
      renderCustomAnchorElement = _ref13.renderCustomAnchorElement,
      tooltip = _ref13.tooltip,
      other = _objectWithoutProperties(_ref13, _excluded);

  var isSelectable = (!!href || !!_onClick) && !isDisabled && !hideStateVisibility;

  var handleClick = function handleClick(event) {
    event.target.focus();

    _onClick(event);
  };
  /* eslint-disable react/prop-types */


  var ListItemTooltip = /*#__PURE__*/React.forwardRef(function (_ref14, listItemRef) {
    var setTooltipText = _ref14.setTooltipText,
        showTooltip = _ref14.showTooltip,
        rest = _objectWithoutProperties(_ref14, _excluded2);

    var tooltipText = tooltip.setTooltipText,
        isTooltipShown = tooltip.showTooltip;
    useEffect(function () {
      if (isBoolean(isTooltipShown)) {
        showTooltip(isTooltipShown);
      }

      if (tooltipText) {
        setTooltipText(tooltipText);
      }
    }, [isTooltipShown, tooltipText]);
    return /*#__PURE__*/_jsx(StyledListItem, _objectSpread(_objectSpread({}, rest), {}, {
      ref: listItemRef
    }));
  });
  /* eslint-enable  */

  var ListItemWithTooltip = !isEmpty(tooltip) ? withTooltip(ListItemTooltip, tooltip.tooltipProps) : StyledListItem; // eslint-disable-next-line react/prop-types

  var ListItemToReturn = function ListItemToReturn(props) {
    var listItemLinkProps = customListItemTag ? _objectSpread({
      onClick: _onClick,
      renderCustomAnchorElement: renderCustomAnchorElement
    }, props) : _objectSpread({
      onClick: function onClick(event) {
        return _onClick(event, props);
      }
    }, props);
    return /*#__PURE__*/_jsx(ElementStateWrapper, _objectSpread(_objectSpread({
      stateStyles: listItemStateStyles,
      useActiveStyles: false,
      useFocusStyles: isSelectable,
      useHoverStyles: false,
      isDisabled: isDisabled
    }, other), {}, {
      children: /*#__PURE__*/_jsx(ListItemWithTooltip, _objectSpread(_objectSpread(_objectSpread(_objectSpread({
        as: customListItemTag || 'a',
        hideStateVisibility: hideStateVisibility,
        isSelectable: isSelectable
      }, other), listItemLinkProps), tooltip === null || tooltip === void 0 ? void 0 : tooltip.positioningProps), {}, {
        children: children
      }))
    }));
  };

  if (renderCustomAnchorElement) {
    return renderCustomAnchorElement(ListItemToReturn);
  }

  if (!renderCustomAnchorElement && href) {
    return /*#__PURE__*/_jsx(ListItemToReturn, {
      href: !isDisabled ? href : undefined,
      ref: ref
    });
  }

  if (_onClick) {
    var onClickProp = !isDisabled ? {
      onClick: handleClick
    } : {};
    return /*#__PURE__*/_jsx(ElementStateWrapper, _objectSpread(_objectSpread({
      stateStyles: isSelected ? listItemSelectedStyles : listItemStateStyles,
      useActiveStyles: false,
      useFocusStyles: isSelectable,
      useHoverStyles: false,
      isDisabled: isDisabled
    }, other), {}, {
      children: /*#__PURE__*/_jsx(ListItemWithTooltip, _objectSpread(_objectSpread(_objectSpread(_objectSpread({
        as: customListItemTag || NormalizedButton,
        disabled: isDisabled,
        hideStateVisibility: hideStateVisibility,
        isSelectable: isSelectable,
        showOutline: true,
        ref: ref,
        type: "button"
      }, onClickProp), other), tooltip === null || tooltip === void 0 ? void 0 : tooltip.positioningProps), {}, {
        children: children
      }))
    }));
  }

  return /*#__PURE__*/_jsx(ListItemWithTooltip, _objectSpread(_objectSpread(_objectSpread({
    as: customListItemTag,
    ref: ref
  }, other), tooltip === null || tooltip === void 0 ? void 0 : tooltip.positioningProps), {}, {
    children: children
  }));
});
ListItem.propTypes = {
  /** Displays any kind of content included between opening and closing tags */
  children: PropTypes.node,

  /** Custom anchor Element */
  customAnchorElement: PropTypes.func,

  /** Ability to supply a different element instead of the default one for ListItem element */
  customListItemTag: PropTypes.elementType,

  /** Changes divider length */
  dividerType: PropTypes.oneOf(Object.values(LIST_ITEM_DIVIDER_TYPES)),

  /** If true, adjusts style when avatar is being displayed */
  hasAvatar: PropTypes.bool,

  /** If true, does not display hover, focus, active states styles */
  hideStateVisibility: PropTypes.bool,

  /** Sets hyperlink for anchor tag */
  href: PropTypes.string,

  /** If true, disables item interactions */
  isDisabled: PropTypes.bool,

  /** Flag to show menu item as selected */
  isSelected: PropTypes.bool,

  /** If true, increases height of the item */
  isMultiLine: PropTypes.bool,

  /** Callback function for item */
  onClick: PropTypes.func,

  /** Custom anchor Element */
  renderCustomAnchorElement: PropTypes.func,

  /** If true, displays divider after each item, if there are more than one */
  showDivider: PropTypes.bool,

  /** Changes list item height */
  size: PropTypes.oneOf(Object.values(LIST_SIZES)),

  /** Display a tooltip */
  tooltip: PropTypes.shape({
    /** Dynamically show/hide tooltip */
    showTooltip: PropTypes.bool,

    /** Dynamically change tooltip text */
    setTooltipText: PropTypes.string,

    /** Tooltip positioning props */
    positioningProps: PropTypes.shape({
      /** Aligns tooltip horizontally by wrapped component */
      horizontalAlignment: PropTypes.oneOf(Object.values(TOOLTIP_HORIZONTAL_ALIGNMENTS)),

      /** Distance between element and tooltip */
      marginAroundElement: PropTypes.number,

      /** Aligns tooltip vertically by wrapped component */
      verticalAlignment: PropTypes.oneOf(Object.values(TOOLTIP_VERTICAL_ALIGNMENTS))
    }),

    /** Tooltip props */
    tooltipProps: PropTypes.shape({
      /** Unique identifier of the component */
      id: PropTypes.string.isRequired,

      /** Inline styles applied to main component wrapper */
      style: PropTypes.shape({}),

      /** Component content */
      text: PropTypes.node.isRequired,

      /** Changes style depending on theme */
      theme: PropTypes.oneOf(Object.values(THEMES))
    })
  })
};
ListItem.defaultProps = {
  children: null,
  customAnchorElement: undefined,
  customListItemTag: undefined,
  dividerType: LIST_ITEM_DIVIDER_TYPES.FULL,
  hasAvatar: false,
  hideStateVisibility: false,
  href: undefined,
  isDisabled: false,
  isMultiLine: false,
  onClick: undefined,
  renderCustomAnchorElement: undefined,
  showDivider: false,
  size: LIST_SIZES.STANDARD,
  tooltip: undefined
};
export { ListItem };